import { useCallback, useReducer } from 'react'
import axios from 'axios'
import { UseHandlers } from './Types'
import { MapUTMSystems } from '@src/data/UtmGenerator'
import { rootReducer } from '@src/containers/UtmGenerator/context'
import { useUtmUserLink } from '@src/containers/UtmGenerator/hooks'
import { deleteProtocol } from '@src/containers/UtmGenerator/helpers'
import { sendAnalyticsEvent } from '@src/utils/sendAnalyticsEvent'
import {
  utmTypeAnalytics,
  GET_PROTOCOL,
  GET_LINK_PAGE,
  GET_SOURCE_TRAFFIC,
  GET_PARAMETERS,
  GET_LOADING_SHORT_LINK,
  GET_SHORT_LINK,
  GET_TRANSLITERATION,
  ERROR_SHORT_LINK
} from '@src/constants'

export function useHandlers(initialState): UseHandlers {
  const [state, dispatch] = useReducer(rootReducer, initialState)
  const [userUtmLink] = useUtmUserLink(
    state.linkPage,
    state.protocol,
    state.utmSource,
    state.utmMedium,
    state.utmCampaign,
    state.utmContent,
    state.utmTerm
  )

  const getLinkPage = useCallback((event: Event) => {
    const target = event.target as HTMLInputElement
    dispatch({ type: GET_LINK_PAGE, payload: deleteProtocol(target.value) })
  }, [])

  const getParameters = useCallback((event: Event) => {
    const target = event.target as HTMLInputElement
    dispatch({ type: GET_PARAMETERS, payload: { name: target.name, value: target.value } })
  }, [])

  const getProtocolName = useCallback((event: Event) => {
    const target = event.target as HTMLButtonElement
    dispatch({ type: GET_PROTOCOL, payload: target.value })
  }, [])

  const getSourceTraffic = useCallback((event: Event) => {
    const target = event.target as HTMLInputElement
    dispatch({ type: GET_SOURCE_TRAFFIC, payload: target.value })

    Object.keys(MapUTMSystems[target.value]).map(key => {
      dispatch({
        type: GET_PARAMETERS,
        payload: { name: key, value: MapUTMSystems[target.value][key] }
      })
    })
  }, [])

  const getTransliteration = useCallback(() => {
    dispatch({ type: GET_TRANSLITERATION })
  }, [])

  const requestForShortLink = useCallback(() => {
    dispatch({ type: GET_LOADING_SHORT_LINK, payload: true })

    axios({
      method: 'post',
      url: '/api/tools/short-link',
      data: { url: encodeURIComponent(userUtmLink) }
    })
      .then(({ data }) => {
        if (Array.isArray(data) || !data.short_url) throw new Error('')

        dispatch({ type: GET_SHORT_LINK, payload: data.short_url })
      })
      .catch(() =>
        dispatch({
          type: ERROR_SHORT_LINK,
          payload: 'Произошла ошибка. Пожалуйста, попробуйте позже.'
        })
      )
  }, [userUtmLink])

  const sendAnalyticCopy = useCallback(() => {
    sendAnalyticsEvent(utmTypeAnalytics.category, utmTypeAnalytics.action, state.traffic)
  }, [state.traffic])

  return [
    { ...state, userUtmLink },
    {
      getProtocolName,
      getLinkPage,
      getSourceTraffic,
      getParameters,
      getTransliteration,
      requestForShortLink,
      sendAnalyticCopy
    }
  ]
}
